import { EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { Nullable } from '@frontend/sports/common/core/utils/extended-types';

import { V1PickId, V2OptionMarketPickId } from '../../core/picks/pick-id';

export interface ILineSwitcherSwapPickState {
    oldPickId: V1PickId | V2OptionMarketPickId;
    newPickId?: Nullable<V1PickId | V2OptionMarketPickId>;
}

export interface ILineSwitcherPossibleWinningsState {
    title: string;
    winnings: string;
    boostedWinnings: string | null;
}

export interface ILineSwitcherSwapButtonState {
    title?: string;
    isDisabled?: boolean;
}

export interface ILineSwitcherErrorState {
    message: string;
    logMessage: string;
}

export const defaultLineSwitcherSwapPickState: ILineSwitcherSwapPickState = {
    oldPickId: new V1PickId('0', 0, 0),
    newPickId: null,
};

export const defaultLineSwitcherPossibleWinningsState: ILineSwitcherPossibleWinningsState = {
    title: '',
    winnings: '',
    boostedWinnings: null,
};

export const defaultLineSwitcherErrorState: ILineSwitcherErrorState = {
    message: '',
    logMessage: '',
};

export interface ILineSwitcherState {
    swapPickState: ILineSwitcherSwapPickState;
    possibleWinningsState: ILineSwitcherPossibleWinningsState;
    swapButtonState: ILineSwitcherSwapButtonState;
    errorState: ILineSwitcherErrorState;
    optionGroup?: EventOptionGroup;
}

export const defaultLineSwitcherState: ILineSwitcherState = {
    swapPickState: defaultLineSwitcherSwapPickState,
    possibleWinningsState: defaultLineSwitcherPossibleWinningsState,
    errorState: defaultLineSwitcherErrorState,
    swapButtonState: {},
};
